module.exports = __webpack_public_path__ + "img/fscgq3.0e00eb53.png";